import { mode } from "@chakra-ui/theme-tools";
export const globalStyles = {
  colors: {
    brand: {
      100: "#EAF2FF",
      200: "#C9DDFF",
      300: "#8FB5FF",
      400: "#5D85FF",
      500: "#2F5BFF",
      600: "#173FD4",
      700: "#122D98",
      800: "#101E63",
      900: "#0A123D",
    },
    brandScheme: {
      100: "#EEE9FF",
      200: "#D8CCFF",
      300: "#B49DFF",
      400: "#8A62FF",
      500: "#6338EA",
      600: "#4C26C2",
      700: "#37198C",
      800: "#26105F",
      900: "#160837",
    },
    brandTabs: {
      100: "#EAF2FF",
      200: "#BFD5FF",
      300: "#8FB5FF",
      400: "#5D85FF",
      500: "#2F5BFF",
      600: "#173FD4",
      700: "#122D98",
      800: "#101E63",
      900: "#0A123D",
    },
    secondaryGray: {
      100: "#E4EAF5",
      200: "#EAF0FA",
      300: "#F5F8FC",
      400: "#DDE6F3",
      500: "#8C99B2",
      600: "#6F7C96",
      700: "#53627D",
      800: "#35435F",
      900: "#17223A",
    },
    red: {
      100: "#FEEFEE",
      300: "#eb7b74",
      500: "#EE5D50",
      600: "#E31A1A",
    },
    blue: {
      50: "#EFF4FB",
      500: "#3965FF",
    },
    orange: {
      100: "#FFF6DA",
      400: "#fde04ce8",
      500: "#FFB547",
    },
    green: {
      100: "#E6FAF5",
      500: "#01B574",
    },
    navy: {
      50: "#DCEAFF",
      100: "#BBD3FF",
      200: "#8FB5FF",
      300: "#608BEE",
      400: "#315EC6",
      500: "#1D429E",
      600: "#183275",
      700: "#132653",
      800: "#0E1A38",
      900: "#08101F",
    },
    gray: {
      100: "#FAFCFE",
      200: "#E2E8F0",
      300: "#CBD5E0",
      400: "#A0AEC0",
      500: "#718096",
      600: "#4A5568",
      700: "#2D3748",
      800: "#1A202C",
      900: "#171923",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        bg: mode("#F6F8FC", "navy.900")(props),
        fontFamily: "Inter,sans-serif",
        letterSpacing: "0",
      },
      input: {
        color: "gray.700",
      },
      html: {
        fontFamily: "Inter,sans-serif",
      },
    }),
  },
};
